import { AddFavoriteSurgicalOrder } from 'domain/usecases/doctor/add-favorite-surgical-order'
import { DoctorRepository } from 'repository/interfaces/doctor-repository'

export class RemoteAddFavoriteSurgicalOrder
  implements AddFavoriteSurgicalOrder
{
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }

  add(
    params: AddFavoriteSurgicalOrder.Params
  ): Promise<AddFavoriteSurgicalOrder.Model> {
    return this.doctorRepository.addFavoriteSurgicalOrder(params)
  }
}
